import request from '@/api/request.js'

/**
 * 标签、别名、音效关系和独立搜索词接口。
 *
 * 标签目录可以被管理页和音效编辑组件共同复用；所有写操作仍由服务端进行
 * 权限、层级和数据量校验，前端这里只负责表达清楚的调用意图。
 */
const apis = {
  /**
   * 读取完整标签组、标签、别名和使用统计。
   *
   * @param {Object} params 可选查询参数
   * @returns {Promise}
   */
  catalog(params = {}) {
    return request({ url: '/admin_sound_tag/catalog', method: 'GET', params })
  },
  /**
   * 新增或修改标签组。
   *
   * @param {Object} params 标签组表单
   * @returns {Promise}
   */
  saveGroup(params) {
    return request({ url: '/admin_sound_tag/saveGroup', method: 'POST', data: params })
  },
  /**
   * 删除没有标签的空标签组。
   *
   * @param {Object} params 必须包含 id
   * @returns {Promise}
   */
  deleteGroup(params) {
    return request({ url: '/admin_sound_tag/deleteGroup', method: 'POST', data: params })
  },
  /**
   * 新增或修改标签及其别名。
   *
   * @param {Object} params 标签表单
   * @returns {Promise}
   */
  saveTag(params) {
    return request({ url: '/admin_sound_tag/saveTag', method: 'POST', data: params })
  },
  /**
   * 删除没有子级和音效关系的标签。
   *
   * @param {Object} params 必须包含 id
   * @returns {Promise}
   */
  deleteTag(params) {
    return request({ url: '/admin_sound_tag/deleteTag', method: 'POST', data: params })
  },
  /**
   * 分页读取待整理音效及标签、搜索词统计。
   *
   * @param {Object} params 筛选和分页参数
   * @returns {Promise}
   */
  sounds(params) {
    return request({ url: '/admin_sound_tag/sounds', method: 'GET', params })
  },
  /**
   * 读取单个音效的标签和独立搜索词。
   *
   * @param {Object} params 必须包含 sound_id
   * @returns {Promise}
   */
  soundDetail(params) {
    return request({ url: '/admin_sound_tag/soundDetail', method: 'GET', params })
  },
  /**
   * 用最终选择结果覆盖单个音效的标签关系。
   *
   * @param {Object} params 包含 sound_id 和 tag_ids
   * @returns {Promise}
   */
  saveSoundTags(params) {
    return request({ url: '/admin_sound_tag/saveSoundTags', method: 'POST', data: params })
  },
  /**
   * 为多个音效批量追加标签，不删除原有关系。
   *
   * @param {Object} params 包含 sound_ids 和 tag_ids
   * @returns {Promise}
   */
  batchAddTags(params) {
    return request({ url: '/admin_sound_tag/batchAddTags', method: 'POST', data: params })
  },
  /**
   * 为单个音效批量添加独立搜索词。
   *
   * @param {Object} params 包含 sound_id 和 terms
   * @returns {Promise}
   */
  saveSearchTerms(params) {
    return request({ url: '/admin_sound_tag/saveSearchTerms', method: 'POST', data: params })
  },
  /**
   * 删除一条独立搜索词。
   *
   * @param {Object} params 必须包含搜索词记录 id
   * @returns {Promise}
   */
  deleteSearchTerm(params) {
    return request({ url: '/admin_sound_tag/deleteSearchTerm', method: 'POST', data: params })
  }
}

export default apis
